import { WorkspaceSettings } from '../core/models/Workspace'
import { DEFAULT_WORKSPACE_SETTINGS } from '../config/defaultSettings'

/**
 * Service to load static workspace settings
 * Used as fallback when cloud settings are unavailable
 */
export const staticSettingsService = {
  /**
   * Load settings from static JSON file
   */
  async loadStaticSettings(): Promise<WorkspaceSettings> {
    try {
      const response = await fetch('/workspace-settings.json')
      if (response.ok) {
        const settings = await response.json()
        return settings
      }
    } catch (error) {
      // Silent fallback to defaults
    }
    
    // Return default settings if static file fails
    return DEFAULT_WORKSPACE_SETTINGS
  },

  /**
   * Get default settings without any network requests
   */
  getDefaultSettings(): WorkspaceSettings {
    return DEFAULT_WORKSPACE_SETTINGS
  }
} 